import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';
import React from 'react';

interface EmptyStateProps {
    icon: LucideIcon;
    title: string;
    description?: string;
    action?: React.ReactNode;
    className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    icon: Icon,
    title,
    description,
    action,
    className
}) => (
    <div
        className={cn(
            'flex flex-col items-center gap-1 py-12 text-center',
            className
        )}
    >
        <Icon className="mb-2 size-5 text-muted-foreground" />
        <p className="text-subtitle text-foreground">{title}</p>
        {description && (
            <p className="text-caption text-muted-foreground">{description}</p>
        )}
        {action && <div className="mt-3">{action}</div>}
    </div>
);
